// extracted by mini-css-extract-plugin
export default {"icon":"success_step___icon___d9d753ce","tada":"success_step___tada___ca4c063e"};